import { render, staticRenderFns } from "./manageRubric.vue?vue&type=template&id=42d7ca8a&lang=html&"
import script from "./manageRubric.vue?vue&type=script&lang=ts&"
export * from "./manageRubric.vue?vue&type=script&lang=ts&"
import style0 from "./manageRubric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports